export const systemCollections = {
	stores: "STORES",
	companies: "COMPANIES",
} as const;

export const storeCollections = {
	products: "products",
	"favorite-products": "favorite-products",
	profiles: "profiles",
	cart: "cart",
	clients: "clients",
	orders: "orders",
	categories: "categories",
	payments: "payments",
	settings: "settings",
	discounts: "discounts",
	organizations: "organizations",
	organizationGroups: "organizationGroups", // todo remove
	invoices: "invoices",
	suppliers: "suppliers",
	supplierInvoices: "supplierInvoices",
	chatSessions: "chatSessions",
	chatSessionMessages: "chatSessionMessages",
	contactSubmissions: "contactSubmissions",
	budgetAccounts: "budgetAccounts",
	budgetTransactions: "budgetTransactions",
	budgetRecords: "budgetRecords",
	organizationBudgets: "organizationBudgets",
	transactions: "transactions",
	paymentLinks: "paymentLinks",
	invoicePaymentLinks: "invoicePaymentLinks",
	duplicateChargeAlerts: "duplicateChargeAlerts",
	organizationBalance: "organizationBalance",
	organizationBalanceRollup: "organizationBalanceRollup",
	creditNotes: "creditNotes",
	/** Business documents (invoice / delivery note / receipt) — see StoreDocument */
	documents: "documents",
} as const;

export const FirestoreApi = {
	systemCollections,
	storeCollections,
	// for client and server
	getPath: ({
		companyId,
		storeId,
		collectionName,
		id,
	}: {
		companyId: string;
		storeId: string;
		collectionName: keyof typeof storeCollections;
		id?: string;
	}) => {
		return `${companyId}/${storeId}/${collectionName}${id ? `/${id}` : ""}`;
	},
	getSubPath: ({
		companyId,
		storeId,
		collectionName,
		subCollectionName,
		id,
		subId,
	}: {
		companyId: string;
		storeId: string;
		collectionName: keyof typeof storeCollections;
		subCollectionName: keyof typeof storeCollections;
		id: string;
		subId?: string;
	}) => {
		return `${companyId}/${storeId}/${collectionName}/${id}/${subCollectionName}${subId ? `/${subId}` : ""}`;
	},
	// for firestore events
	getDocPath: (collectionName: keyof typeof storeCollections) => {
		return `{companyId}/{storeId}/${collectionName}/{id}`;
	},
	getSubDocPath: (
		collectionName: keyof typeof storeCollections,
		id: string,
		subCollectionName: keyof typeof storeCollections,
	) => {
		return `{companyId}/{storeId}/${collectionName}/${id}/${subCollectionName}/{id}`;
	},
};

export const FirebaseAPI = {
	firestore: FirestoreApi,
};
